export const REVIEWS_SEARCH_ID = 'reviews-search';

export const ALL_STAR_RATINGS = 'ALL_STAR_RATINGS';

export const INITIAL_PAGE_LIMIT = 8;
export const SUBSEQUENT_PAGE_LIMIT = 30;
export const ONE_STAR_RATING = 1;

export const SORT_BY_OPTION = {
  NEWEST: 'NEWEST',
  HIGHEST_RATING: 'HIGHEST_RATING',
  LOWEST_RATING: 'LOWEST_RATING',
  PHOTO_REVIEWS: 'PHOTO_REVIEWS',
};

export const SORT_BY_OPTIONS = [
  {
    value: SORT_BY_OPTION.NEWEST,
    displayValue: 'Newest',
  },
  {
    value: SORT_BY_OPTION.HIGHEST_RATING,
    displayValue: 'Highest rating',
  },
  {
    value: SORT_BY_OPTION.LOWEST_RATING,
    displayValue: 'Lowest rating',
  },
  {
    value: SORT_BY_OPTION.PHOTO_REVIEWS,
    displayValue: 'Photo reviews',
  },
];

export const FILTER_BY_OPTIONS = [
  {
    value: ALL_STAR_RATINGS,
    displayValue: 'All reviews',
  },
  {
    value: 5,
    displayValue: '5 stars',
  },
  {
    value: 4,
    displayValue: '4 stars',
  },
  {
    value: 3,
    displayValue: '3 stars',
  },
  {
    value: 2,
    displayValue: '2 stars',
  },
  {
    value: 1,
    displayValue: '1 star',
  },
];

export const ALL_STAR_RATINGS_VALUE = ALL_STAR_RATINGS;

export const BADGES_TOOLTIPS = {
  incentivizedReview: 'This reviewer received an incentive to write this review. An incentive can be a coupon, sample product, sweepstakes entry, loyalty points, or other token of value in exchange for writing a review for this product.',
  staff:
  /**
   * @param {string} brand
   * @returns {string}
   */
  (brand) => `Staff Contributor is someone who works on behalf of ${brand} and has been identified as someone who understands the product from the company’s perspective.`,
};

export const REVIEWS_REDIRECT_MAP = {
  writeAReview: '/shop/product/review/add',
};

export const LOADING_STATE = {
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  ERROR: 'ERROR',
};
